import t from "./createLocalTimezoneMoment.mjs";
import "moment";
function r(e) {
  return t(e).toDate();
}
export {
  r as default
};
